import {
  FormControl,
  FormHelperText,
  FormLabel,
  GridLegacy as Grid,
} from '@mui/material';
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SurveyQuestion } from '../../types';
import { useSxStyles } from '../useStyles';

import { CheckBoxGroupController } from './CheckBoxGroupController';

type Props = {
  question: SurveyQuestion;
  control: Control;
};

export const MultipleChoice: React.FC<Props> = ({ control, question }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  return (
    <Grid
      container
      item
      xs={12}
      direction="row"
      key={question.id}
      justifyContent="space-between"
    >
      <FormControl sx={sxStyles.formControl} fullWidth required>
        <Grid item sx={{ ...sxStyles.question, ...sxStyles.stretch }}>
          <FormLabel sx={sxStyles.formControlLabel}>{question.text}</FormLabel>
          <FormHelperText id={`${question.index}-helper-free-text`}>
            {t('label_select_all_apply')}
          </FormHelperText>
        </Grid>
        <Grid item sx={sxStyles.stretch}>
          <Controller
            control={control}
            name={`${question.id}`}
            defaultValue={[]}
            rules={{
              validate: {
                required: (v) => v.length > 0 || `${t('laThisRequired')}`,
              },
            }}
            render={({ field: { onChange, value } }) => (
              <CheckBoxGroupController
                values={value}
                onChange={onChange}
                question={question}
              />
            )}
          />
        </Grid>
      </FormControl>
    </Grid>
  );
};
